import React from 'react';
import { Phone, Mail, MapPin, FileText, ExternalLink } from 'lucide-react';
import { CONTACT } from '../mock';

export default function Contact() {
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent('Samruddi Nilaya, Jodi Bhavi Road, Rukmini Nagar, Nagasandra, Bangalore 560073')}`;

  return (
    <section id="contact" className="bg-[#0f0f10] text-white py-24 md:py-32">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16">
        <div>
          <span className="text-[11px] font-semibold tracking-[0.18em] text-[#FFB37A]">GET IN TOUCH</span>
          <h2 className="mt-3 text-[34px] md:text-[46px] font-semibold tracking-[-0.02em] leading-[1.05]">
            Visit our Bangalore office
          </h2>
          <p className="mt-4 text-[15px] md:text-[17px] text-white/65 leading-relaxed max-w-md">
            We are a small, hands-on team. Drop in, call, or write — we read every message.
          </p>

          {/* Bangalore office location embed */}
          <div className="mt-8 rounded-3xl overflow-hidden ring-1 ring-white/10 relative aspect-[16/10] hidden md:block bg-[#161618]">
            <iframe
              title="ON THE WAY Bangalore office"
              src="https://www.openstreetmap.org/export/embed.html?bbox=77.4895%2C13.0335%2C77.5395%2C13.0635&layer=mapnik&marker=13.0485%2C77.5145"
              className="absolute inset-0 w-full h-full border-0 grayscale-[0.2] contrast-[1.05]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0f0f10]/85 via-transparent to-transparent pointer-events-none" />
            <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between pointer-events-none">
              <div className="text-[13px] text-white/90 font-medium drop-shadow">Nagasandra, Bangalore</div>
              <a
                href={mapsUrl}
                target="_blank"
                rel="noreferrer"
                className="pointer-events-auto inline-flex items-center gap-1.5 bg-white text-[#0f0f10] text-[12.5px] font-semibold rounded-full px-3.5 py-2 hover:bg-white/90 transition-colors"
              >
                Open in Maps <ExternalLink size={12} />
              </a>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <InfoCard icon={MapPin} title="HEAD OFFICE">
            {CONTACT.addressLines.map((l) => <div key={l}>{l}</div>)}
          </InfoCard>
          <InfoCard icon={Phone} title="PHONE">
            <a href={`tel:${CONTACT.phone.replace(/\s/g, '')}`} className="text-white text-[16px] font-semibold hover:text-[#FF6A1A] transition-colors">{CONTACT.phone}</a>
            <div className="text-white/55 text-[13px] mt-1">24/7 customer & driver support</div>
          </InfoCard>
          <InfoCard icon={Mail} title="EMAIL">
            <a href={`mailto:${CONTACT.email}`} className="text-white text-[16px] font-semibold hover:text-[#FF6A1A] transition-colors">{CONTACT.email}</a>
            <div className="text-white/55 text-[13px] mt-1">Replies within 4 hours</div>
          </InfoCard>
          <InfoCard icon={FileText} title="GSTIN">
            <span className="font-mono text-[14.5px] text-white/85">{CONTACT.gstin}</span>
          </InfoCard>
        </div>
      </div>
    </section>
  );
}

function InfoCard({ icon: Icon, title, children }) {
  return (
    <div className="bg-[#161618] ring-1 ring-white/5 rounded-2xl p-5 md:p-6 hover:ring-[#FF6A1A]/40 transition-colors">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-xl bg-[#FF6A1A]/15 text-[#FF6A1A] grid place-items-center flex-shrink-0">
          <Icon size={18} />
        </div>
        <div className="flex-1">
          <div className="text-[10.5px] font-semibold tracking-[0.18em] text-white/55">{title}</div>
          <div className="mt-1.5 text-[14.5px] text-white/80 leading-relaxed">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
